import React from 'react'
import ReactDOM from 'react-dom'
import NavLink from './NavLink'

import config from '../config'

import FadeIn from './FadeIn'

class MailtoLink extends React.Component {
  constructor(props) {
    super(props);
  }

  mailto(e) {
    e.preventDefault();
    window.location.href = 'mailto:' + config.helloEmail;
  }

  componentDidMount() {
    const el = ReactDOM.findDOMNode(this)
    el.addEventListener("click", this.mailto )
  }

  render() {
    return (
        <NavLink to='#'>{config.helloEmail}</NavLink>
    );
  }
}

export default MailtoLink



// WEBPACK FOOTER //
// ./src/components/MailToLink.js